import React from "react";
import "./LandscapeWrapper.scss";
interface LandscapeWrapperProps {
  children: any;
}
const LandscapeWrapper: React.FC<LandscapeWrapperProps> = ({ children }) => {
  return <div className='landscape-container'>{children}</div>;
};
export default LandscapeWrapper;
